import { Dispatch, MouseEventHandler, SetStateAction } from 'react';
import styled from 'styled-components';
import Draggable from 'react-draggable';
import useWindowSize from '../../hooks/useWindowSize';

const StretchBar = styled.div`
  position: fixed;
  top: 0;
  width: 6px;
  height: 100vh;
  cursor: col-resize;
  z-index: ${({ theme }) => theme.zIndex.drawer + 4};
`;

type Props = {
  width: number;
  minWidth: number;
  maxWidth: number;
  onDrag: Dispatch<SetStateAction<number>>;
  onDragStart?: () => void;
  onDragEnd?: () => void;
  onMouseEnter: MouseEventHandler<HTMLDivElement>;
  onMouseLeave: MouseEventHandler<HTMLDivElement>;
  direction?: 'left-to-right' | 'right-to-left';
  positionOffset?: { x: number; y: number };
  rightOffset?: number;
};

const ResizablePanelHorizontal = ({
  width,
  minWidth,
  maxWidth,
  onDrag,
  onDragStart,
  onDragEnd,
  onMouseEnter,
  onMouseLeave,
  direction = 'left-to-right',
  positionOffset,
  rightOffset = 0,
}: Props) => {
  const { width: windowWidth = 0 } = useWindowSize();
  const effectiveWindowWidth = windowWidth - rightOffset;

  const adjustedBounds =
    direction === 'left-to-right'
      ? { left: minWidth, right: maxWidth }
      : {
          left: effectiveWindowWidth - maxWidth,
          right: effectiveWindowWidth - minWidth,
        };

  const handleDrag = (e: any, { deltaX }: { deltaX: number }) => {
    const newWidth =
      direction === 'left-to-right' ? width + deltaX : width - deltaX;
    onDrag(newWidth);
  };

  const positionX =
    direction === 'left-to-right'
      ? width > maxWidth
        ? maxWidth
        : width
      : width > maxWidth
      ? effectiveWindowWidth - maxWidth
      : effectiveWindowWidth - width;

  return (
    <Draggable
      axis="x"
      position={{ x: positionX, y: 0 }}
      onDrag={handleDrag}
      bounds={adjustedBounds}
      onStart={onDragStart}
      onStop={onDragEnd}
      positionOffset={positionOffset}
    >
      <StretchBar onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />
    </Draggable>
  );
};

export default ResizablePanelHorizontal;
